import { TDateField, TImageField, TSitecoreContext, TStringField } from '../../../../../types/sitecore.types';
import { TLatestNewsCardItemProps } from '../../../types/latestNews.types';

export class NewsCardModel {
  private readonly item?: TLatestNewsCardItemProps;
  private readonly context?: TSitecoreContext;

  constructor(props: TLatestNewsCardItemProps, context: TSitecoreContext) {
    this.item = props;
    this.context = context;
  }

  get title(): TStringField | undefined {
    return {
      value: this.item?.title,
    };
  }

  get shortDescription(): TStringField | undefined {
    return {
      value: this.item?.shortDescription,
    };
  }

  get newsDate(): TDateField | undefined {
    return { value: this.item?.newsDate };
  }

  get contextLanguage(): string {
    return this.context?.language || 'en-GB';
  }

  get tag(): TStringField | undefined {
    if (this.item?.tagCategories?.length) {
      return {
        value: this.item?.tagCategories?.[0]?.name,
      };
    }
    return { value: '' };
  }

  get ctaLink(): string | undefined {
    return this.item?.link;
  }

  get showVideo(): boolean | undefined {
    return this.item?.useVideo === '1';
  }

  get image(): TImageField | undefined {
    return this.item?.Image;
  }

  get mobileImage(): TImageField | undefined {
    return this.item?.MobileImage;
  }

  get video(): string | undefined {
    return this.item?.video;
  }
}
